import React from 'react'
import {Alert, Spin, Typography} from 'antd'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'

import '../../asset/less/Pieces.less'
import {onPaginationSave} from '../../action/style'
import ArtworkPiecesPanel from '../../component/piece/ArtworkPiecesPanel'

const {Title} = Typography

@connect(
    (state) => ({
        id: state.user.info.id, // real user id, admin_id or artist_id
        userId: state.user.info.userId, // artist user obj id
        artistId: state.user.info.artistId, // artist obj id
        artistName: state.user.info.artistName,
        email: state.user.info.email,
        role: state.user.info.role,
        plan: state.user.plan
    }),
    {
        onPaginationSave
    }
)
class Pieces extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            rawData: []
        }

        this.artistId = this.props.artistId

        this.search_key = props.location?.search ?? ''
        this.inViewOnly = false
        if (this.search_key) {
            try {
                const keys = this.search_key.split("&")
                for (let i = 0; i < keys.length; i++) {
                    const key = keys[i]
                    if (key.startsWith("?artistId=")) {
                        this.inViewOnly = true
                        this.artistId = key.replace("?artistId=", "")
                    }
                }
            } catch (e) {

            }
        }
    }

    componentDidMount() {
    }

    onDataUpdate = (data) => {
        this.setState({
            rawData: data
        })
    }

    render() {
        return (
            <Spin size='large' spinning={this.state.loading}>
                <div className='site-layout-background'>
                    {this.inViewOnly && (
                         <Alert
                          message="You are in the artists pieces view only mode"
                          type="warning"
                        />
                    )}
                    <ArtworkPiecesPanel
                        id={this.props.id}
                        artistId={this.artistId}
                        artistName={this.props.artistName}
                        location={this.props.location}
                        role={this.props.role}
                        history={this.props.history}
                        onDataUpdate={this.onDataUpdate}
                    />
                </div>
            </Spin>
        )
    }
}

export default withRouter(Pieces)
